import { QueryObserverResult, useQuery } from 'react-query';
import useApiService from '../utilities/useApiService';
import { isRoleIncluded } from '../utilities/checkUserRole';
import { UserRole } from '../utilities/Enums';
import { useAuthState } from '../context/AuthContext';
import { IReturnRequestDto } from '../network/models/RetrunRequestInterfaces';

export const useReturnRequest = (
   pharmacyId: string,
   requestId: string,
   forbiddenRoles: UserRole[] = []
): [
   IReturnRequestDto | undefined,
   () => void,
   Omit<QueryObserverResult<any>, 'data' | 'refetch'>
] => {
   const { getMethod } = useApiService();
   const { user } = useAuthState();

   const roleForbidden = isRoleIncluded(forbiddenRoles, user?.role);

   const { data, refetch, ...state } = useQuery({
      queryKey: [`/pharmacies/${pharmacyId}/returnrequests/${requestId}`],
      queryFn: (context) => {
         if (roleForbidden || !requestId) return undefined;

         return getMethod<IReturnRequestDto>(
            `/pharmacies/${pharmacyId}/returnrequests/${requestId}`,
            { signal: context.signal }
         );
      },
      select: (response) => response?.data,
   });

   return [data, () => refetch({ cancelRefetch: true }), state];
};
